import React, { useState, useEffect, useContext } from "react";
import { AuthContext } from "../../../contexts/AuthContext";
import OportunidadesCreate from "./OportunidadesCreate";
import axios from "axios";
import {
  Button,
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  Input,
  Label,
  Row,
  Col,
} from "reactstrap";
import Header from "../../../layout/Header/Header";
import Swal from "sweetalert2";
import { jsPDF } from "jspdf";
import "jspdf-autotable";
import { puedeCrm } from "../permisosCrm";
import { etiquetasEtapas } from "../etapas";
import { lineasActivas } from "../lineas";
import { sectorDe, BadgeSector, pasaFiltroSector, OpcionesFiltroSector } from "../sectores";
import { excelCrm, fechaCortaCrm, textoFiltroSector } from "../exportaCrm";

function PipelineKanban() {
  const { user } = useContext(AuthContext);
  const URL_CRM_OPORTUNIDADES = process.env.REACT_APP_URL_CRM_OPORTUNIDADES;
  const URL_CRM_ETAPAS = process.env.REACT_APP_URL_CRM_ETAPAS;
  const URL_LINEAS = process.env.REACT_APP_URL_SUBDEPARTAMENTOS;
  const URL_LOGS = process.env.REACT_APP_URL_LOGS;

  const [etapas, setEtapas] = useState([]);
  const [oportunidades, setOportunidades] = useState([]);
  const [lineas, setLineas] = useState([]);
  const [filtroLinea, setFiltroLinea] = useState("");
  const [filtroSector, setFiltroSector] = useState("");

  const [modalCreate, setModalCreate] = useState(false);
  const toggleCreate = () => setModalCreate(!modalCreate);

  const [modalEtapa, setModalEtapa] = useState(false);
  const toggleEtapa = () => setModalEtapa(!modalEtapa);
  const [opSel, setOpSel] = useState(null);
  const [nuevaEtapa, setNuevaEtapa] = useState("");
  const [comentario, setComentario] = useState("");
  const [motivoPerdida, setMotivoPerdida] = useState("");
  const [fechaProxima, setFechaProxima] = useState("");

  // (2026-10) Langiani: carga de las oportunidades abiertas en función, para
  // refrescar el tablero después de mover una sin recargar la página
  function getAbiertas() {
    axios
      .get(`${URL_CRM_OPORTUNIDADES}Abiertas`, {
        headers: { Authorization: `Bearer: ${localStorage.getItem("app_token")}` },
      })
      .then((r) => setOportunidades(r.data))
      .catch((e) => console.log(e));
  }

  useEffect(() => {
    const headers = { headers: { Authorization: `Bearer: ${localStorage.getItem("app_token")}` } };
    axios
      .get(URL_CRM_ETAPAS, headers)
      .then((r) => setEtapas(r.data.sort((a, b) => (a.orden > b.orden ? 1 : -1))))
      .catch((e) => console.log(e));
    getAbiertas();
    axios
      .get(URL_LINEAS, headers)
      .then((r) => setLineas(lineasActivas(r.data)))
      .catch((e) => console.log(e));
  }, []);

  function abreCambioEtapa(op) {
    if (!puedeCrm(user, "crm.embudo.mover")) return; // sin permiso solo puede consultar
    setOpSel(op);
    setNuevaEtapa(op.etapa ? op.etapa._id : "");
    setComentario("");
    setMotivoPerdida("");
    setFechaProxima(op.fecha_proxima_accion || "");
    toggleEtapa();
  }

  const etapaSelObj = etapas.find((e) => e._id === nuevaEtapa);
  const esPerdida = etapaSelObj && etapaSelObj.tipo === "perdida";

  function guardarCambioEtapa() {
    if (!nuevaEtapa) {
      Swal.fire("Atencion", "Selecciona una etapa", "warning");
      return;
    }
    if (esPerdida && !motivoPerdida) {
      Swal.fire("Atencion", "Indica el motivo de perdida", "warning");
      return;
    }
    const hoy = new Date().toISOString().split("T")[0];
    axios
      .patch(
        `${URL_CRM_OPORTUNIDADES}Etapa/${opSel._id}`,
        {
          etapa: nuevaEtapa,
          usuario: user.id,
          usuarioNombre: user.nombre,
          comentario,
          fecha_proxima_accion: fechaProxima,
          fecha: hoy,
          motivo_perdida: motivoPerdida,
        },
        { headers: { Authorization: `Bearer: ${localStorage.getItem("app_token")}` } }
      )
      .then(() => {
        axios.post(
          URL_LOGS,
          { tipo: "Cambiar Etapa Oportunidad", detalle: opSel.titulo, user: user.id },
          { headers: { Authorization: `Bearer: ${localStorage.getItem("app_token")}` } }
        );
        toggleEtapa();
        Swal.fire("Listo!", "Etapa actualizada", "success");
        // (2026-10) Langiani: sin recargar la página, se refrescan los datos
        getAbiertas();
      })
      .catch((error) => {
        Swal.fire({
          icon: "error",
          title: "Oops...",
          text: "Something went wrong!",
          footer: `${error.response ? error.response.data.message || error.response.data : error}`,
        });
      });
  }

  const opsPorEtapa = (etapaId) =>
    oportunidades.filter(
      (o) =>
        o.etapa &&
        o.etapa._id === etapaId &&
        (!filtroLinea ||
          (o.lineas || []).some((c) => (c._id || c) === filtroLinea)) &&
        pasaFiltroSector(o.prospecto, filtroSector)
    );

  const totalEtapa = (etapaId) =>
    opsPorEtapa(etapaId).reduce((acc, o) => acc + Number(o.valor_estimado || 0), 0);

  const etapasAbiertas = etapas.filter((e) => e.tipo === "abierta");
  const etiquetaEtapa = etiquetasEtapas(etapas);

  // (2026-10) PDF del embudo con los filtros de la pantalla (sector y línea):
  // resumen por etapa (oportunidades, valor y valor ponderado por la
  // probabilidad) y el detalle de cada oportunidad con su siguiente reunión.
  function PDFEmbudo() {
    const doc = new jsPDF("landscape");
    const pageW = doc.internal.pageSize.getWidth();
    const pageH = doc.internal.pageSize.getHeight();
    const ML = 12;
    const azul = [0, 58, 92];
    const fondo = [238, 244, 255];
    const dinero = (n) =>
      "$" + Number(n || 0).toLocaleString("es-MX", { maximumFractionDigits: 0 });
    const fechaCorta = (f) => {
      const [a, m, d] = String(f || "").slice(0, 10).split("-");
      return a && m && d ? `${d}/${m}/${a}` : "";
    };
    const hoy = new Date().toISOString().slice(0, 10);

    const textoSector =
      filtroSector === "sin" ? "Sin sector" : filtroSector || "Todos los sectores";
    const lineaSel = lineas.find((l) => l._id === filtroLinea);
    const textoLinea = lineaSel ? `Línea: ${lineaSel.name}` : "Todas las líneas";

    // ---- Encabezado
    doc.setFont(undefined, "bold").setFontSize(16).setTextColor(...azul);
    doc.text("EMBUDO DE VENTAS", ML, 16);
    doc.setFontSize(10).setTextColor(60, 60, 60).setFont(undefined, "normal");
    doc.text(`Sector: ${textoSector}   ·   ${textoLinea}`, ML, 23);
    doc.text(`Fecha: ${fechaCorta(hoy)}`, pageW - ML, 16, { align: "right" });

    // ---- Resumen por etapa
    let totOps = 0;
    let totValor = 0;
    let totPonderado = 0;
    const resumen = etapasAbiertas.map((e) => {
      const ops = opsPorEtapa(e._id);
      const valor = ops.reduce((t, o) => t + Number(o.valor_estimado || 0), 0);
      const ponderado = ops.reduce(
        (t, o) => t + (Number(o.valor_estimado || 0) * Number(o.probabilidad || 0)) / 100,
        0
      );
      totOps += ops.length;
      totValor += valor;
      totPonderado += ponderado;
      return [etiquetaEtapa[e._id], ops.length, dinero(valor), `${e.probabilidad || 0}%`, dinero(ponderado)];
    });
    doc.autoTable({
      startY: 28,
      margin: { left: ML, right: ML },
      tableWidth: 170,
      theme: "grid",
      head: [["ETAPA", "OPORTUNIDADES", "VALOR", "PROB.", "VALOR PONDERADO"]],
      body: resumen,
      foot: [[
        "TOTAL",
        { content: totOps, styles: { halign: "center" } },
        { content: dinero(totValor), styles: { halign: "right" } },
        "",
        { content: dinero(totPonderado), styles: { halign: "right" } },
      ]],
      styles: { fontSize: 9, cellPadding: 1.8 },
      headStyles: { fillColor: azul, textColor: 255, halign: "center" },
      footStyles: { fillColor: fondo, textColor: azul, fontStyle: "bold" },
      columnStyles: {
        1: { halign: "center" },
        2: { halign: "right" },
        3: { halign: "center" },
        4: { halign: "right" },
      },
    });

    // ---- Detalle por etapa
    const cuerpo = [];
    etapasAbiertas.forEach((e) => {
      // dentro de cada etapa, por fecha de la siguiente reunión (sin fecha al final)
      const ops = opsPorEtapa(e._id)
        .slice()
        .sort((a, b) =>
          String(a.fecha_proxima_accion || "9999").localeCompare(String(b.fecha_proxima_accion || "9999"))
        );
      if (!ops.length) return;
      cuerpo.push([
        {
          content: `${etiquetaEtapa[e._id]}  (${ops.length})`,
          colSpan: 7,
          styles: { fillColor: fondo, textColor: azul, fontStyle: "bold" },
        },
      ]);
      ops.forEach((o) => {
        const p = o.prospecto || {};
        const reunion = o.fecha_proxima_accion
          ? `${fechaCorta(o.fecha_proxima_accion)}${o.fecha_proxima_accion < hoy ? " (vencida)" : ""}` +
            (o.proxima_accion && o.proxima_accion !== "NA" ? `\n${o.proxima_accion}` : "")
          : "";
        cuerpo.push([
          p.razon_social || o.titulo || "",
          sectorDe(p) || "Sin sector",
          (o.lineas || []).map((l) => l.name).join(", "),
          o.responsable ? `${o.responsable.nombre || ""} ${o.responsable.apellido || ""}`.trim() : "",
          dinero(o.valor_estimado),
          `${o.probabilidad || 0}%`,
          reunion,
        ]);
      });
    });
    doc.autoTable({
      startY: doc.autoTable.previous.finalY + 8,
      margin: { left: ML, right: ML, bottom: 16 },
      theme: "grid",
      head: [["PROSPECTO", "SECTOR", "LÍNEAS", "RESPONSABLE", "VALOR", "PROB.", "SIGUIENTE REUNIÓN"]],
      body: cuerpo.length
        ? cuerpo
        : [[{ content: "Sin oportunidades con estos filtros.", colSpan: 7 }]],
      styles: { fontSize: 8.5, cellPadding: 1.6, valign: "middle" },
      rowPageBreak: "avoid",
      headStyles: { fillColor: azul, textColor: 255, halign: "center" },
      columnStyles: {
        0: { cellWidth: 62 },
        1: { cellWidth: 22, halign: "center" },
        2: { cellWidth: 48 },
        3: { cellWidth: 38 },
        4: { cellWidth: 26, halign: "right" },
        5: { cellWidth: 14, halign: "center" },
      },
    });

    // ---- Pie con páginas
    const n = doc.internal.getNumberOfPages();
    for (let i = 1; i <= n; i++) {
      doc.setPage(i);
      doc.setFontSize(8).setTextColor(100, 100, 100);
      doc.text(`Embudo de Ventas · ${textoSector}`, ML, pageH - 7);
      doc.text(`Página ${i} de ${n}`, pageW - ML, pageH - 7, { align: "right" });
    }

    const sufijo = filtroSector === "sin" ? " - Sin sector" : filtroSector ? ` - ${filtroSector}` : "";
    doc.save(`Embudo de Ventas${sufijo}.pdf`);
  }

  // (2026-10) Excel del embudo con los mismos filtros: hoja Resumen por etapa y
  // hoja Detalle con cada oportunidad
  function excelEmbudo() {
    const resumen = etapasAbiertas.map((e) => {
      const ops = opsPorEtapa(e._id);
      const valor = ops.reduce((t, o) => t + Number(o.valor_estimado || 0), 0);
      const ponderado = ops.reduce(
        (t, o) => t + (Number(o.valor_estimado || 0) * Number(o.probabilidad || 0)) / 100,
        0
      );
      return [etiquetaEtapa[e._id], ops.length, valor, `${e.probabilidad || 0}%`, Math.round(ponderado)];
    });
    const detalle = [];
    etapasAbiertas.forEach((e) =>
      opsPorEtapa(e._id)
        .slice()
        .sort((a, b) =>
          String(a.fecha_proxima_accion || "9999").localeCompare(String(b.fecha_proxima_accion || "9999"))
        )
        .forEach((o) => {
          const p = o.prospecto || {};
          detalle.push([
            etiquetaEtapa[e._id],
            p.razon_social || o.titulo || "",
            sectorDe(p) || "Sin sector",
            (o.lineas || []).map((l) => l.name).join(", "),
            o.responsable ? `${o.responsable.nombre || ""} ${o.responsable.apellido || ""}`.trim() : "",
            Number(o.valor_estimado || 0),
            `${o.probabilidad || 0}%`,
            fechaCortaCrm(o.fecha_proxima_accion),
            o.proxima_accion && o.proxima_accion !== "NA" ? o.proxima_accion : "",
          ]);
        })
    );
    excelCrm({
      archivo: `Embudo de Ventas${filtroSector ? ` - ${textoFiltroSector(filtroSector)}` : ""}`,
      hojas: [
        {
          nombre: "Detalle",
          columnas: ["Etapa", "Prospecto", "Sector", "Líneas", "Responsable", "Valor", "Prob.", "Siguiente reunión", "Próxima acción"],
          filas: detalle,
        },
        {
          nombre: "Resumen",
          columnas: ["Etapa", "Oportunidades", "Valor", "Prob.", "Valor ponderado"],
          filas: resumen,
        },
      ],
    });
  }

  return (
    <>
      <Header />
      <br />
      <div className="container-fluid">
        {puedeCrm(user, "crm.embudo.ver") ? (
          <div className="card col-12">
            <Row>
              <Col md={8}>
                <Button size="sm" href="/MenuCrm" className="btn btn-danger" id="botonListado">
                  Regresar
                </Button>
              </Col>
              <Col sm={4} className="d-flex" style={{ gap: 8 }}>
                <Input type="select" bsSize="sm" value={filtroSector} onChange={(e) => setFiltroSector(e.target.value)}>
                  <OpcionesFiltroSector />
                </Input>
                <Input type="select" bsSize="sm" value={filtroLinea} onChange={(e) => setFiltroLinea(e.target.value)}>
                  <option value="">Todas las líneas</option>
                  {lineas.map((c) => (
                    <option key={c._id} value={c._id}>{c.name}</option>
                  ))}
                </Input>
                <Button size="sm" className="btn" color="danger" onClick={PDFEmbudo} style={{ whiteSpace: "nowrap" }}>
                  PDF <i className="far fa-file-pdf"></i>
                </Button>
                <Button size="sm" className="btn" color="primary" onClick={excelEmbudo} style={{ whiteSpace: "nowrap" }}>
                  Excel <i className="far fa-file-excel"></i>
                </Button>

              </Col>
            </Row>
            <h3 align="center">Embudo Ventas</h3>

            {etapasAbiertas.length === 0 ? (
              <p style={{ padding: 16 }}>
                No hay etapas configuradas. Ve a <b>Etapas</b> y carga el pipeline por defecto.
              </p>
            ) : (
              <div style={{ display: "flex", gap: 12, overflowX: "auto", paddingBottom: 12 }}>
                {etapasAbiertas.map((et) => (
                  <div
                    key={et._id}
                    style={{
                      minWidth: 260,
                      flex: "0 0 260px",
                      background: "#f6f7fb",
                      borderRadius: 10,
                      padding: 8,
                    }}
                  >
                    <div
                      style={{
                        borderTop: `4px solid ${et.color}`,
                        borderRadius: 6,
                        background: "#fff",
                        padding: "8px 10px",
                        marginBottom: 8,
                      }}
                    >
                      <div style={{ fontWeight: 600, fontSize: "0.85rem" }}>{etiquetaEtapa[et._id]}</div>
                      <div style={{ fontSize: "0.72rem", color: "#6b7280" }}>
                        {opsPorEtapa(et._id).length} deals · $
                        {totalEtapa(et._id).toLocaleString("es-MX")}
                      </div>
                    </div>

                    {opsPorEtapa(et._id).map((o) => (
                      <div
                        key={o._id}
                        onClick={() => abreCambioEtapa(o)}
                        style={{
                          background: "#fff",
                          borderRadius: 8,
                          padding: 10,
                          marginBottom: 8,
                          boxShadow: "0 1px 3px rgba(0,0,0,0.08)",
                          cursor: "pointer",
                        }}
                      >
                        <div style={{ fontWeight: 600, fontSize: "0.82rem" }}>{o.titulo}</div>
                        <div style={{ fontSize: "0.74rem", color: "#6b7280" }}>
                          {o.prospecto ? o.prospecto.razon_social : ""}{" "}
                          {o.prospecto && o.prospecto.sector && o.prospecto.sector !== "NA" ? (
                            <BadgeSector prospecto={o.prospecto} />
                          ) : null}
                        </div>
                        <div style={{ fontSize: "0.78rem", marginTop: 4 }}>
                          <b>${Number(o.valor_estimado || 0).toLocaleString("es-MX")}</b>
                          <span style={{ float: "right", color: "#6b7280" }}>{o.probabilidad}%</span>
                        </div>
                        {o.responsable && (
                          <div style={{ fontSize: "0.7rem", color: "#003A5C", marginTop: 3 }}>
                            <i className="fas fa-user" style={{ marginRight: 4 }} />
                            {o.responsable.nombre} {o.responsable.apellido || ""}
                          </div>
                        )}
                      </div>
                    ))}
                  </div>
                ))}
              </div>
            )}
          </div>
        ) : undefined}
      </div>

      {/* Alta */}
      <Modal size="lg" isOpen={modalCreate} toggle={toggleCreate}>
        <ModalHeader toggle={toggleCreate}>
          Nueva Oportunidad
        </ModalHeader>
        <ModalBody>
          <OportunidadesCreate
            onSaved={() => {
              setModalCreate(false);
              getAbiertas();
            }}
          />
        </ModalBody>
      </Modal>

      {/* Cambiar etapa */}
      <Modal size="md" isOpen={modalEtapa} toggle={toggleEtapa}>
        <ModalHeader toggle={toggleEtapa}>
          {opSel ? opSel.titulo : "Mover de etapa"}
        </ModalHeader>
        <ModalBody>
          <Label>Etapa</Label>
          <Input type="select" value={nuevaEtapa} onChange={(e) => setNuevaEtapa(e.target.value)}>
            <option value="">Selecciona...</option>
            {etapas.map((et) => (
              <option key={et._id} value={et._id}>
                {etiquetaEtapa[et._id]}
              </option>
            ))}
          </Input>
          <br />
          <Label>Fecha siguiente reunión</Label>
          <Input type="date" value={fechaProxima} onChange={(e) => setFechaProxima(e.target.value)} />
          <br />
          <Label>Comentario</Label>
          <Input type="textarea" value={comentario} onChange={(e) => setComentario(e.target.value)} />
          {esPerdida && (
            <>
              <br />
              <Label style={{ color: "#dc3545" }}>Motivo de perdida *</Label>
              <Input
                type="text"
                value={motivoPerdida}
                onChange={(e) => setMotivoPerdida(e.target.value)}
              />
            </>
          )}
        </ModalBody>
        <ModalFooter>
          <Button color="success" onClick={guardarCambioEtapa}>
            Guardar
          </Button>
        </ModalFooter>
      </Modal>
    </>
  );
}

export default PipelineKanban;
